import { Link } from 'react-router-dom';

const STATS = [
  { value: '150+', label: '在追事件' },
  { value: '900+', label: '时间线节点' },
  { value: '60+', label: '已收录结局' },
];

export default function Hero() {
  return (
    <section className="relative flex h-[560px] w-full items-center overflow-hidden md:h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20stylized%20backdrop%20of%20a%20watermelon%20slice%20silhouette%20with%20deep%20crimson%20and%20forest%20green%20gradients%2C%20dramatic%20moody%20lighting%2C%20fine%20art%20texture%2C%20minimal%20composition%20with%20lots%20of%20empty%20space%20for%20text%2C%20editorial%20poster%20style&width=1800&height=1100&seq=xg-hero-main&orientation=landscape"
        alt="西瓜黑料主题背景图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="mx-auto max-w-4xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur-sm">
            <i className="ri-history-line"></i>
            吃瓜时间线 · 反转与结局持续更新
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            西瓜黑料
            <span className="mt-3 block text-xl font-semibold text-background-100 md:text-3xl">
              按时间线追完每一出瓜，连结局都不落下
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
            每一段瓜都从第一幕排到最后一幕：起始、后续瓜、反转、续集、进度与结局一次看全。不用再翻几十条碎片消息，在这里就能看完一整出连续剧般的吃瓜大戏。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/dramas"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-400"
            >
              <i className="ri-play-list-2-line text-lg"></i>
              进入瓜田开始追
            </Link>
            <Link
              to="/about"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-7 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors duration-200 hover:bg-background-50/20"
            >
              我们如何整理时间线
            </Link>
          </div>

          <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
            {STATS.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-background-100/70">{stat.label}</dt>
                <dd className="font-heading text-2xl font-bold text-background-50">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}